module.exports = "/_next/static/images/invest-line-4e69ef0b235ec5e6890c4e60424ec985.svg";